export default __webpack_public_path__ + "static/media/265.3379a264.jpg";